import ProductsAPI from '@/api/ProductsAPI.js';
import httpClient from '@/api/axios-httpclient';
import { MSEnum } from '@/common/enumeration';

export default {
	/**
	 * Lấy danh sách của hàng hóa dịch vụ
	 */
	getProducts: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: ProductsAPI.getAPIUrl() + '/all',
			params: payload
		});

		if (res.Success) {
			if (
				payload.TaxableType == MSEnum.TaxableTypeEnum.SpecialConsumption
			) {
				context.commit('updateSpecialConsumptionProducst', res);
			} else if (
				payload.TaxableType ==
				MSEnum.TaxableTypeEnum.TaxProtectEnvironment
			) {
				context.commit('updateEnviromentTaxProducts', res);
			} else if (
				payload.TaxableType ==
				MSEnum.TaxableTypeEnum.FeesProtectEnvironment
			) {
				context.commit('updateEnviromentFeesProducts', res);
			} else if (
				payload.TaxableType == MSEnum.TaxableTypeEnum.FeesAndCharges
			) {
				context.commit('updateFeesChargesProducts', res);
			} else if (payload.TaxableType == MSEnum.TaxableTypeEnum.GTGT) {
				context.commit('updateTypeWorksProducts', res);
			}
		}
	}
};
